<template>
  <div class="app-loading-progress app-loading-progress--bars">
    <scale-loader :loading="true" :color="color" :height="height" :width="width"></scale-loader>
  </div>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  name: 'AppLoadingProgressBars',

  components: {
    ScaleLoader,
  },

  props: {
    width: {
      type: String,
      default: '5px',
    },

    height: {
      type: String,
      default: '45px',
    },

    color: {
      type: String,
      default: '#9b9dd1',
    },
  },
}
</script>

<style scoped></style>
